import { z } from 'zod';

export const UISubmissionStatuses = ['RECEIVED', 'READY', 'ERROR', 'FAILED', 'PROCESSING', 'DELETED'] as const;

export type UISubmissionStatus = (typeof UISubmissionStatuses)[number];

export type UISubmissionStatusLabels = { [key in UISubmissionStatus]: string };

export const UISubmissionStatusFilter = z.union([z.enum(UISubmissionStatuses), z.literal('All')]);
export type UISubmissionStatusFilter = z.infer<typeof UISubmissionStatusFilter>;

export const UISubmissionStatusLabels: UISubmissionStatusLabels = {
    FAILED: 'Warning',
    RECEIVED: 'Received',
    PROCESSING: 'Processing',
    ERROR: 'Error',
    READY: 'Ready',
    DELETED: 'Deleted',
};

export const TooltipMessages: UISubmissionStatusLabels = {
    READY: 'Ready - Form is ready for download.',
    PROCESSING:
        'Processing - Form is being created. Check status in the "Submitted form requests" section for updates.',
    ERROR: 'Error - We are experiencing technical issues with your request. Please try again, and if the problem persists, please contact support at (763) 406-3411.',
    FAILED: 'Warning - The Request contained an invalid value or lacked proper permissions. Please provide a valid value and resubmit the request.',
    RECEIVED: 'Received - Form is pending processing.',
    DELETED: 'Deleted - Form has been deleted.',
};

export const FORM_TYPES = ['F10', 'F20'] as const;

export const FormType = z.enum(FORM_TYPES);
export type FormType = z.infer<typeof FormType>;

export const FormTypeFilter = z.union([FormType, z.literal('All')]);
export type FormTypeFilter = z.infer<typeof FormTypeFilter>;

const Filters = z.object({
    tcId: z.number().nullable().default(null),
    rid: z.string().default(''),
    formType: FormTypeFilter.default('All'),
    status: UISubmissionStatusFilter.default('All'),
});
export type Filters = z.infer<typeof Filters>;

// TODO some of these things should probably be moved closer to the ui rather than the "types" library
export const DEFAULT_FILTERS: Filters = {
    rid: '',
    tcId: null,
    status: 'All',
    formType: 'All',
};
